package one.healthium.decompose

import androidx.compose.animation.core.FiniteAnimationSpec
import androidx.compose.animation.core.tween
import androidx.compose.foundation.gestures.Orientation
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.layout
import com.arkivanov.decompose.extensions.compose.stack.animation.Direction
import com.arkivanov.decompose.extensions.compose.stack.animation.StackAnimator
import com.arkivanov.decompose.extensions.compose.stack.animation.stackAnimator
import kotlin.math.abs

fun parallax(
    animationSpec: FiniteAnimationSpec<Float> = tween(),
    orientation: Orientation = Orientation.Horizontal,
): StackAnimator =
    stackAnimator(animationSpec = animationSpec) { factor, direction, content ->
        content(
            when (orientation) {
                Orientation.Horizontal -> horizontalParallax(factor, direction)
                Orientation.Vertical -> verticalParallax(factor, direction)
            }
        )
    }

fun horizontalParallax(factor: Float, direction: Direction): Modifier {
    return when (direction) {
        Direction.ENTER_FRONT -> Modifier.offsetXFactor(factor)
        Direction.EXIT_FRONT -> Modifier.offsetXFactor(factor)
        Direction.ENTER_BACK -> Modifier
            .offsetXFactor(factor * 0.2f)
            .fade(abs(factor))

        Direction.EXIT_BACK -> Modifier
            .offsetXFactor(factor * 0.2f)
            .fade(abs(factor))
    }
}

fun verticalParallax(factor: Float, direction: Direction): Modifier {
    return when (direction) {
        Direction.ENTER_FRONT -> Modifier.offsetYFactor(factor)
        Direction.EXIT_FRONT -> Modifier.offsetYFactor(factor)
        Direction.ENTER_BACK -> Modifier
            .offsetYFactor(factor * 0.2f)
            .fade(abs(factor))

        Direction.EXIT_BACK -> Modifier
            .offsetYFactor(factor * 0.2f)
            .fade(abs(factor))
    }
}


fun Modifier.offsetXFactor(factor: Float): Modifier =
    layout { measurable, constraints ->
        val placeable = measurable.measure(constraints)

        layout(placeable.width, placeable.height) {
            placeable.placeRelative(x = (placeable.width.toFloat() * factor).toInt(), y = 0)
        }
    }

fun Modifier.offsetYFactor(factor: Float): Modifier =
    layout { measurable, constraints ->
        val placeable = measurable.measure(constraints)

        layout(placeable.width, placeable.height) {
            placeable.placeRelative(x = 0, y = (placeable.height.toFloat() * factor).toInt())
        }
    }

fun Modifier.fade(factor: Float): Modifier =
    drawWithContent {
        drawContent()
        drawRect(Color.Black.copy(alpha = 0.35f * factor))
    }
